import { RootState } from '../../store';

export const getDepartmentsSelector = (state: RootState) => state?.departmentReducer?.departments;
